// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.gradient-button {
  margin: 10px;
  font-family: "Arial Black", Gadget, sans-serif;
  font-size: 20px;
  padding: 15px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  color: #FFF;
  box-shadow: 0 0 20px #eee;
  border-radius: 10px;
  width: 200px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  cursor: pointer;
  display: inline-block;
  border-radius: 25px;
}
.gradient-button:hover{
  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
  margin: 8px 10px 12px;
}
.gradient-button-2 {background-image: linear-gradient(to right, #2BC0E4 0%, #EAECC6 51%, #2BC0E4 100%)}
.gradient-button-2:hover { background-position: right center; }

.boarder-descp-login {
  width: 500px;
  height: 300px;
  padding: 50px;
  border: 4px inset rgba(28,110,164,0.82);
  border-radius: 20px;

}

#land-page-main-block-descp{
	float: left;
	width: 70%;
	padding: 15px;
  box-sizing: border-box;
  margin-top: 30px;
}

#landpge-sidebar-ex{
	float: right;
	width: 30%;
	/* #333 = dark gray */
	background-color: #333;
	/* #fff= white */
	color: #fff;
	padding: 15px;
  box-sizing: border-box;
  margin-top: 30px;
}

.clr{
	/* used to clear any floats */
	clear:both;
}

.table-hover tbody tr:hover td, .table-hover tbody tr:hover th {
  /* background-color: #b19cd9; */
  /*background-color: rgba(41, 241, 195, 1); - this is the old green color*/
  background-color: rgba(0, 76, 102, 1);
  color: white;
  cursor: pointer;
}

.table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
  background-color: #C0C0C0;
}

/* .table-striped > tbody > tr:nth-child(2n+1):hover > td, .table-striped > tbody > tr:nth-child(2n+1):hover > th {
  background-color: rgba(0, 76, 102, 1);
} */

/* .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
  background-color: #add8e6;
}

.table-hover tbody tr:hover td, .table-hover tbody tr:hover th {
  background-color: #b19cd9;
  cursor: pointer;
}

.table-hover tbody tr:hover td:nth-child(1){
   background-color: #b19cd9;
   border-radius: 8px 0 0 8px; 
   box-shadow: 7px 6px 7px 1px rgba(0, 0, 0, 0.061); 
   text-decoration: none; 
   border: none; 
   font-size: 16px; 
   color: #fff; 
   outline: none; 
   transition: 0.2s all; 
}

.table-hover tbody tr:hover td:last-child{
  background-color: #b19cd9;
  border-radius: 0 8px 8px 0; 
  box-shadow: 7px 6px 7px 1px rgba(0, 0, 0, 0.061); 
  text-decoration: none; 
  border: none; 
  font-size: 16px; 
  color: #fff; 
  outline: none; 
  transition: 0.2s all; 
} */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,YAAY;EACZ,8CAA8C;EAC9C,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kEAAkE;EAClE,+CAA+C;EAC/C,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,oEAAoE;EACpE,qBAAqB;AACvB;AACA,oBAAoB,kFAAkF;AACtG,2BAA2B,iCAAiC,EAAE;;AAE9D;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uCAAuC;EACvC,mBAAmB;;AAErB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,aAAa;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,WAAW;CACX,aAAa;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;CACC,6BAA6B;CAC7B,UAAU;AACX;;AAEA;EACE,+BAA+B;EAC/B,yEAAyE;EACzE,qCAAqC;EACrC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA+BG","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.gradient-button {\n  margin: 10px;\n  font-family: \"Arial Black\", Gadget, sans-serif;\n  font-size: 20px;\n  padding: 15px;\n  text-align: center;\n  text-transform: uppercase;\n  transition: 0.5s;\n  background-size: 200% auto;\n  color: #FFF;\n  box-shadow: 0 0 20px #eee;\n  border-radius: 10px;\n  width: 200px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n  transition: all 0.3s cubic-bezier(.25,.8,.25,1);\n  cursor: pointer;\n  display: inline-block;\n  border-radius: 25px;\n}\n.gradient-button:hover{\n  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n  margin: 8px 10px 12px;\n}\n.gradient-button-2 {background-image: linear-gradient(to right, #2BC0E4 0%, #EAECC6 51%, #2BC0E4 100%)}\n.gradient-button-2:hover { background-position: right center; }\n\n.boarder-descp-login {\n  width: 500px;\n  height: 300px;\n  padding: 50px;\n  border: 4px inset rgba(28,110,164,0.82);\n  border-radius: 20px;\n\n}\n\n#land-page-main-block-descp{\n\tfloat: left;\n\twidth: 70%;\n\tpadding: 15px;\n  box-sizing: border-box;\n  margin-top: 30px;\n}\n\n#landpge-sidebar-ex{\n\tfloat: right;\n\twidth: 30%;\n\t/* #333 = dark gray */\n\tbackground-color: #333;\n\t/* #fff= white */\n\tcolor: #fff;\n\tpadding: 15px;\n  box-sizing: border-box;\n  margin-top: 30px;\n}\n\n.clr{\n\t/* used to clear any floats */\n\tclear:both;\n}\n\n.table-hover tbody tr:hover td, .table-hover tbody tr:hover th {\n  /* background-color: #b19cd9; */\n  /*background-color: rgba(41, 241, 195, 1); - this is the old green color*/\n  background-color: rgba(0, 76, 102, 1);\n  color: white;\n  cursor: pointer;\n}\n\n.table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {\n  background-color: #C0C0C0;\n}\n\n/* .table-striped > tbody > tr:nth-child(2n+1):hover > td, .table-striped > tbody > tr:nth-child(2n+1):hover > th {\n  background-color: rgba(0, 76, 102, 1);\n} */\n\n/* .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {\n  background-color: #add8e6;\n}\n\n.table-hover tbody tr:hover td, .table-hover tbody tr:hover th {\n  background-color: #b19cd9;\n  cursor: pointer;\n}\n\n.table-hover tbody tr:hover td:nth-child(1){\n   background-color: #b19cd9;\n   border-radius: 8px 0 0 8px; \n   box-shadow: 7px 6px 7px 1px rgba(0, 0, 0, 0.061); \n   text-decoration: none; \n   border: none; \n   font-size: 16px; \n   color: #fff; \n   outline: none; \n   transition: 0.2s all; \n}\n\n.table-hover tbody tr:hover td:last-child{\n  background-color: #b19cd9;\n  border-radius: 0 8px 8px 0; \n  box-shadow: 7px 6px 7px 1px rgba(0, 0, 0, 0.061); \n  text-decoration: none; \n  border: none; \n  font-size: 16px; \n  color: #fff; \n  outline: none; \n  transition: 0.2s all; \n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
